import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { ApiPaymentType } from '../../shared/enums/api-payment-type.enum';
import { RequestService } from '../../shared/services/request.service';
import { WalletInvoice } from './models/wallet-deposit.model';
import { WalletStatementFilter, WalletStatementResponse } from './models/wallet-statement.model';
import { Wallet } from './models/wallet.model';

@Injectable()
export class WalletService {
  constructor(private requestService: RequestService) {}

  async getWallet(storeId: number): Promise<Wallet> {
    const urlRequest = `${APP_CONFIG.WEBSERVICE.WALLET}?entity=STORE&entityId=${storeId}`;
    return await this.requestService.getData(urlRequest);
  }

  async updateRechargeConfig(wallet: Wallet): Promise<void> {
    let data = wallet.toJsonUpdate();
    return await this.requestService.putData(APP_CONFIG.WEBSERVICE.WALLET, data);
  }

  async deposit(
    storeId: number,
    value: number,
    paymentType: ApiPaymentType
  ): Promise<WalletInvoice> {
    const urlRequest = this.requestService.buildUrlPathParams(
      { storeId: storeId },
      APP_CONFIG.WEBSERVICE.WALLET_DEPOSIT
    );
    let data = {
      value: value,
      paymentType: paymentType.toUpperCase(),
    };
    return await this.requestService.postData(urlRequest, data);
  }

  async getLastInvoice(storeId: number): Promise<WalletInvoice> {
    const urlRequest =
      APP_CONFIG.WEBSERVICE.WALLET_LAST_INVOICE + '?entity=STORE&entityId=' + storeId;
    return await this.requestService.getData(urlRequest);
  }

  async getWalletStatement(
    storeId: number,
    filter: WalletStatementFilter
  ): Promise<WalletStatementResponse> {
    let urlRequest = this.requestService.buildUrlPathParams(
      {
        storeId: storeId,
      },
      APP_CONFIG.WEBSERVICE.WALLET_STATEMENT
    );
    urlRequest += '?' + this.requestService.buildUrlParams(filter);
    const response = await this.requestService.getData(urlRequest);
    return new WalletStatementResponse(response);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/wallet/wallet.service.ts